import React, { useState, useEffect } from 'react';
import { db } from '../firebaseConfig';
// eslint-disable-next-line no-unused-vars
import { collection, query, where, orderBy, onSnapshot } from 'firebase/firestore';
import { useAuth } from '../context/AuthContext';
import { IoPersonCircleOutline, IoChevronForward } from 'react-icons/io5';
import moment from 'moment';

const MuroChatList = ({ onSelectChat }) => {
    const { currentUser } = useAuth();
    const [chats, setChats] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!currentUser) return;

        const chatsRef = collection(db, 'muro_chats');
        // Query chats where user is a participant
        // Note: array-contains requires an index usually, checking rules.
        const q = query(
            chatsRef,
            where('participants', 'array-contains', currentUser.uid)
        );

        const unsubscribe = onSnapshot(q, (snapshot) => {
            const chatsData = snapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            })).sort((a, b) => {
                const timeA = a.lastMessageTime?.seconds || 0;
                const timeB = b.lastMessageTime?.seconds || 0;
                return timeB - timeA;
            });
            setChats(chatsData);
            setLoading(false);
        });

        return () => unsubscribe();
    }, [currentUser]);

    if (loading) return <div style={{ padding: 20, textAlign: 'center' }}>Cargando conversaciones...</div>;

    if (chats.length === 0) {
        return (
            <div className="empty-state">
                <IoPersonCircleOutline size={48} color="#9ca3af" />
                <h3>No tienes mensajes</h3>
                <p>Contacta a alguien en el Muro para iniciar un chat.</p>
            </div>
        );
    }

    return (
        <div className="muro-feed-grid" style={{ gridTemplateColumns: '1fr' }}>
            {chats.map(chat => {
                // eslint-disable-next-line no-unused-vars
                const otherUser = chat.participantsData?.[
                    chat.participants.find(uid => uid !== currentUser.uid)
                ] || { nombre: 'Usuario' };
                // Creating a fallback if participantsData isn't fully synced or available
                // Ideally, we store "displayNames" map in the chat doc.

                // For now, let's assume `chat.participantNames` map exists or we just show "Chat"
                // Or better, we store `chat.residentNames = { uid: "Name" }`.

                const otherName = chat.residentNames ? chat.residentNames[chat.participants.find(uid => uid !== currentUser.uid)] : "Usuario";

                return (
                    <div
                        key={chat.id}
                        className="post-card-stitch"
                        onClick={() => onSelectChat(chat)}
                        style={{ cursor: 'pointer', display: 'flex', flexDirection: 'row', alignItems: 'center', padding: '16px' }}
                    >
                        <div className="post-avatar-stitch" style={{ marginRight: 16 }}>
                            {otherName.charAt(0).toUpperCase()}
                        </div>
                        <div style={{ flex: 1 }}>
                            <div style={{ fontWeight: 600, color: '#1f2937' }}>
                                {otherName}
                                <span style={{ fontWeight: 400, color: '#6b7280', fontSize: '0.9rem', marginLeft: 8 }}>
                                    • {chat.postTitle}
                                </span>
                            </div>
                            <div style={{ color: '#4b5563', fontSize: '0.95rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                {chat.lastMessage}
                            </div>
                        </div>
                        <div style={{ fontSize: '0.8rem', color: '#9ca3af' }}>
                            {chat.lastMessageTime?.toDate ? moment(chat.lastMessageTime.toDate()).fromNow() : ''}
                        </div>
                        <IoChevronForward style={{ marginLeft: 10, color: '#d1d5db' }} />
                    </div>
                );
            })}
        </div>
    );
};

export default MuroChatList;
